import * as styles from "./AddContactModalStyles";
import { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import ReTab from "../../unity-ui-common/Components/ReTab";
import ReModal from "../../unity-ui-common/Components/ReModal";
import ManageContactSafetyDoc from "../Management/ManageContactsSafetyDoc/ManageContactSafetyDoc";
import { convertToSimpleCaseFromCamelCase } from "../../Helper/Methods";
import { distributions } from "../../API/Distribution"; // Import distributions API
import { ReNotification } from "../../unity-ui-common/Components/ReNotification";
import { Button, Divider, Result } from "antd";



type ApiResponse = {
  statusCode?: number; // Use `?` if it's optional
  error?: string; // Include any other fields the API may return
  data?: any; // Include other specific response data if applicable
};

function AddContactModal(props: {
  visibility: boolean;
  setVisibility: any;
  safetyDocumentID: string | undefined;
  flag: boolean;
  setFlag: Function;
}) {
  const { visibility, setVisibility, safetyDocumentID, flag, setFlag } = props;
  const [activeTabId, setActiveTabId] = useState<string>("1");
  const [selectedContacts, setSelectedContacts] = useState<string[]>([]); // Stores selected contact IDs
  const [loading, setLoading] = useState(false); // Loading state for submission

  const listTabItems = [
    {
      title: "All Contacts",
      key: "1",
      children: getCommonTable(),
    },
  ];

  function getCommonTable() {
    return <ManageContactSafetyDoc onSelectContacts={setSelectedContacts} safetyDocumentID={""} distributions={undefined} setFlag={function (flag: boolean): void {
      throw new Error("Function not implemented.");
    } } flag={false} setVisibility={function (visible: boolean): void {
      throw new Error("Function not implemented.");
    } } ReNotification={function (options: { description: string; duration: number; placement: string; type: string; }): void {
      throw new Error("Function not implemented.");
    } }/>;
  }


  // Handle form submission (similar to handleSubmit in ImportContactListModal)
  const handleSubmit = async () => {
    if (!safetyDocumentID) throw new Error("Safety Document ID not found");
    if (selectedContacts.length === 0) {
      ReNotification({
        description: "Please select at least one contact.",
        duration: 1000,
        placement: "bottomLeft",
        type: "error",
      });
      return;
    }

    setLoading(true);

    try {
      // Call the addContactToSafetyDoc method from the distributions API
      const res = await distributions.addContactToSafetyDoc(safetyDocumentID, selectedContacts);
      if (!res?.statusCode) {
        ReNotification({
          description: "Contacts added successfully.",
          duration: 1000,
          placement: "bottomLeft",
          type: "success",
        });
        setFlag(!flag); // Trigger flag to refresh data or UI
        setVisibility(false); // Close the modal
      } else {
        ReNotification({
          description: convertToSimpleCaseFromCamelCase(res.error),
          duration: 1000,
          placement: "bottomLeft",
          type: "error",
        });
      }
    } catch (error) {
      ReNotification({
        description: "An error occurred while adding contacts.",
        duration: 1000,
        placement: "bottomLeft",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <styles.Container>
      <ReModal
        style={{ marginTop: -72 }}
        visibility={visibility}
        onCancel={() => {
          setVisibility(false);
        }}
        closable={false}
        width={1160}
        title={
          <styles.ModalHeader>
            <CloseOutlined
              onClick={() => {
                setVisibility(false);
              }}
            />
            <h3>Add Contact</h3>
          </styles.ModalHeader>
        }
        footer={
          <styles.ModalFooter>
            {selectedContacts.length > 0 && (
              <Button
                onClick={handleSubmit}
                disabled={loading}
                type="primary"
              >
                {loading ? "Adding..." : "Add Contacts"}
              </Button>
            )}
          </styles.ModalFooter>
        }
      >
        <styles.ModalBody>
          <>
            <h2 className="heading">
              Select the Contacts which needs to be added
            </h2>

            <ReTab
              onChange={(id: any) => setActiveTabId(id)}
              activeKey={activeTabId}
              items={listTabItems}
            />
          </>
        </styles.ModalBody>
      </ReModal>
    </styles.Container>
  );
}

export default AddContactModal;
